import { FC } from 'react';
import Box, { BoxProps } from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import NewChip from 'app/components/NewChip';
import { SNACK_TRAY_AVAILABLE_LABEL } from 'app/constants/snackTrayPromo';

interface Props {
  // 'inline' puts the chip and caption side by side; 'stacked' centers the
  // caption beneath the chip (used in the vertical Home stroller rail).
  layout?: 'inline' | 'stacked';
  fontSize?: number;
  sx?: BoxProps['sx'];
}

const SnackTrayAvailableLine: FC<Props> = ({
  layout = 'inline',
  fontSize = 12,
  sx,
}) => {
  const stacked = layout === 'stacked';

  return (
    <Box
      display="flex"
      flexDirection={stacked ? 'column' : 'row'}
      alignItems="center"
      sx={sx}
    >
      <NewChip />
      <Typography
        component="div"
        align={stacked ? 'center' : undefined}
        sx={{
          fontSize: `${fontSize}px`,
          lineHeight: `${fontSize + 4}px`,
          fontStyle: 'italic',
          color: 'secondary.darker',
          ...(stacked ? { mt: '4px' } : { ml: 1 }),
        }}
      >
        {SNACK_TRAY_AVAILABLE_LABEL}
      </Typography>
    </Box>
  );
};

export default SnackTrayAvailableLine;
